import React from 'react';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {Route, Switch, withRouter} from 'react-router-dom';
import rawTheme from './../../../theme.json';
import LoginForm from './LoginForm';
import ResetPassword from './ResetPassword';
import ExternalAppBar from "../../organisms/app-bar/ExternalAppBar";
import SignupForm from "./SignupForm";
import ActivateUserPage from "./ActivateUserPage";


const muiTheme = createTheme(rawTheme);

function Login() {
  return (
    <MuiThemeProvider theme={muiTheme}>
      <ExternalAppBar />
      <div className='login' style={{padding:'0 1rem'}}>
        <Switch>
          <Route exact path="/login" component={LoginForm}/>
          <Route exact path="/signup" component={SignupForm}/>
          <Route path="/activate/:token" component={ActivateUserPage}/>
          <Route path="/login/reset-password" component={ResetPassword}/>
        </Switch>
      </div>
    </MuiThemeProvider>
  );
}

export default withRouter(Login);
